<template>
  <div>
    <div class="additional-information">
      <p class="title">OnSite TVU Operator</p>
      <el-form
        :rules="rules"
        ref="additionalInfo"
        class="additional-info"
        size="medium"
        :model="additionalInfo"
      >
        <div class="flex-center">
          <el-form-item prop="operatorFirstName" label="First Name">
            <el-input v-model="additionalInfo.operatorFirstName"></el-input>
          </el-form-item>
          <el-form-item prop="operatorLastName" label="Last Name">
            <el-input v-model="additionalInfo.operatorLastName"></el-input>
          </el-form-item>
        </div>
        <div class="flex-center">
          <el-form-item prop="operatorCompanyName" label="Company Name">
            <el-input v-model="additionalInfo.operatorCompanyName"></el-input>
          </el-form-item>
          <el-form-item prop="operatorEmailAddress" label="Email Address">
            <el-input v-model="additionalInfo.operatorEmailAddress"></el-input>
          </el-form-item>
        </div>
        <div class="flex-center border-bottom">
          <el-form-item prop="operatorIFB" label="">
            <div class="operator-IFB">
              <el-checkbox v-model="additionalInfo.sendRentalRequestConfirmationMailToOperator"></el-checkbox>
              &nbsp;
              <span class="name">Send confirmation email to TVU Operator</span>
            </div>
          </el-form-item>
        </div>
        <el-form-item prop="operatorGreenToolkitLink" label="Green Toolkit Link">
          <el-input v-model="additionalInfo.operatorGreenToolkitLink"></el-input>
        </el-form-item>
        <el-form-item prop="operatorIFB" label="">
          <div class="operator-IFB">
            <span class="name">IFB</span>
            <el-checkbox v-model="additionalInfo.operatorIFB"></el-checkbox>
          </div>
        </el-form-item>
        <el-form-item prop="operatorNote" label="Note">
          <el-input
            type="textarea"
            v-model="additionalInfo.operatorNote"
            :rows="4"
            placeholder="Free text"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="next-box">
      <el-button size="small" type="primary" @click="onNext">Next</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdditionalInformation',
  data () {
    return {
      additionalInfo: {
        operatorFirstName: '',
        operatorLastName: '',
        operatorCompanyName: '',
        operatorEmailAddress: '',
        operatorGreenToolkitLink: '',
        operatorIFB: false,
        operatorNote: '',
        sendRentalRequestConfirmationMailToOperator: false
      }
    }
  },
  computed: {
    rules () {
      return {
        operatorFirstName: [
          {
            // required: true,
            message: 'Please complete this required field.',
            trigger: 'blur'
          }
        ],
        operatorLastName: [
          {
            // required: true,
            message: 'Please complete this required field.',
            trigger: 'blur'
          }
        ],
        operatorEmailAddress: [
          {
            // required: true,
            message: 'Please complete this required field.',
            trigger: 'blur'
          },
          { pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: 'Invalid Email Formats!', trigger: 'blur' }
        ],
        operatorGreenToolkitLink: [
          {
            // required: true,
            message: 'Please complete this required field.',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted () {
    const additionalInfo = localStorage.getItem('additionalInfo') ? JSON.parse(localStorage.getItem('additionalInfo')) : null
    if (additionalInfo) {
      this.additionalInfo = additionalInfo
      this.additionalInfo.operatorIFB = !!additionalInfo.operatorIFB
    }
  },
  methods: {
    onNext () {
      this.$refs.additionalInfo.validate(valid => {
        if (valid) {
          localStorage.setItem('additionalInfo', JSON.stringify(this.additionalInfo))
          this.$emit('additionalNext', JSON.stringify(this.additionalInfo))
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.additional-information {
  padding: 24px 64px;
  border-radius: 4px;
  border: 2px solid #DBDBDB;
  background: #FAFAFA;

  .title {
    color: #69AD48;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 18px;
  }

  /deep/ .el-input__inner, /deep/ .el-textarea__inner {
    border-color: #DBDBDB;
    background: #FAFAFA !important;
  }

  /deep/ .el-input__inner::placeholder {
    color: #DBDBDB;
  }

  .additional-info .flex-center {
    display: flex;

    /deep/ .el-input__inner {
      width: 492px;
    }

    :nth-child(2).el-form-item {
      margin-left: 16px;
    }
  }

  .border-bottom {
    border-bottom: 2px dashed #DBDBDB;
    margin-bottom: 16px;
  }

  .operator-IFB {
    .name {
      color: #000;
      margin-right: 6px;
    }
  }
}

.next-box {
  text-align: right;
  margin-top: 36px;
}
</style>
